import React from "react";
import Back from "../common/back/Back";
import "./policies.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <Back title="Privacy Policy" />
      <div className="container policy-container">
        <div className="policy-content">
          <h2>1. Introduction</h2>
          <p>Welcome to Welsh Education. We respect your privacy and are committed to protecting your personal data.</p>
          
          <h2>2. Data We Collect</h2>
          <p>We may collect, use, store and transfer different kinds of personal data about you, including Identity Data, Contact Data, and Technical Data.</p>

          <h2>3. How We Use Your Data</h2>
          <p>We will only use your personal data when the law allows us to. Most commonly, we will use your personal data to provide our services, manage our relationship with you, and improve our website.</p>

          <h2>4. Data Security</h2>
          <p>We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way.</p>

          <h2>5. Your Legal Rights</h2>
          <p>Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, or erasure.</p>

          <h2>6. Contact Us</h2>
          <p>If you have any questions about this privacy policy or our privacy practices, please contact us at info@welsheducation.com.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
